import { getAppColor } from '@security/@arch/lib';
import { isEqual } from 'lodash';
import { useApplicationReferences } from '@hooks/references';
import { usePrevious } from '@hooks/usePrevious';
import { useEffect, useState } from 'react';
export function useDataSecurityAppColors(appIds) {
    const [applicationColors, setApplicationColors] = useState({});
    const apps = useApplicationReferences();
    const previousAppIds = usePrevious(appIds);
    useEffect(() => {
        if (appIds && !isEqual(appIds, previousAppIds)) {
            appIds.forEach((id) => {
                var _a;
                const { name } = (_a = apps[id]) !== null && _a !== void 0 ? _a : {};
                getAppColor(name, (color) => {
                    setApplicationColors((colors) => (Object.assign(Object.assign({}, colors), { [id]: color })));
                });
            });
        }
    }, [appIds, applicationColors, apps, previousAppIds]);
    return applicationColors;
}
